import * as types from './mutation-types'
import { LOAD_PAYMENT_METHOD } from './mutation-types';
import orderFormSignature from './orderFormSignature'

const emptyCart = () => ({ products: {}, bundles: {}, currentProduct: {}, checkoutMode: '', payments: [], clientId: null, note: '', discount: 0 })

// note et remise globale propres à chaque panier (onglet) : enregistrées avec lui
function persistCartField(state, sellerId, field, value) {
  if (!sellerId) return
  let carts = getCartsFromStorage(sellerId, state.currentCart)
  carts[state.currentCart][field] = value
  localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
}

function getCartsFromStorage(sellerId, currentCart) {
  let carts = JSON.parse(localStorage.getItem('carts' + sellerId)) || {}
  if (!carts[currentCart]) {
    carts[currentCart] = emptyCart()
  }
  return carts
}

function computeCartTotal(products) {
  let price = 0
  Object.values(products || {}).forEach(product => {
    if (parseFloat(product.price_offset) == 0) {
      price += parseFloat(
        product.hasPromotion
          ? (product.price_ttc_promo - ((product.price_ttc_promo * product.remise) / 100))
          : (product.price_ttc - ((product.price_ttc * product.remise) / 100))
      ) * parseFloat(product.number)
    } else {
      price += parseFloat(product.price_offset - ((product.price_offset * product.remise) / 100)) * parseFloat(product.number)
    }
  })
  return price
}

// Total estimatif des packs du panier — prix affiché au moment de l'ajout
// (price_ttc du pack), la remise/prix réel est recalculé côté serveur au
// checkout (voir Pay::computeBundleTotal).
function computeBundleCartTotal(bundles) {
  let price = 0
  Object.values(bundles || {}).forEach(bundle => {
    price += parseFloat(bundle.price_ttc) * parseFloat(bundle.number)
  })
  return price
}

const deleteFormatProduct = function (state, deleteProduct) {
  const productIdToDelete = deleteProduct.product_id;
  if (typeof state.products === 'object' && state.products !== null) {
    const updatedProducts = { ...state.products };
    if (productIdToDelete in updatedProducts) {
      delete updatedProducts[productIdToDelete];
      state.products = updatedProducts;
      state.currentProduct = {};
    } else {
      console.error(`Product with ID ${productIdToDelete} not found`);
    }
  } else {
    console.error('state.products is not a valid object');
  }
};

export default {
  ADD_PRODUCT: function (state, selectedProduct) {
    let product = state.products[selectedProduct.id] || { number: 0 }
    const sellerId = this.getters['session/getSellerId']
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    let currentCart = carts[state.currentCart]


    product.product_id = selectedProduct.id
    product.number++
    product.price_ttc = selectedProduct.price_ttc
    product.hasPromotion = selectedProduct.hasPromotion
    product.price_ttc_promo = selectedProduct.price_ttc_promo
    product.title = selectedProduct.title,
    product.remise = product.remise ? product.remise : 0
    product.price_offset = product.price_offset ? product.price_offset : 0
    product.declinaison = selectedProduct.declinaison
    product.currency_iso = selectedProduct.currency_iso
    product.currency = selectedProduct.currency
    state.currentProduct.product_id = selectedProduct.id
    state.currentProduct.product_id = selectedProduct.id

    state.products = {...state.products, ...{[selectedProduct.id]: product}}

    // stockage des produits dans le localStorage
    currentCart.products = state.products
    carts = {...carts, [state.currentCart]: currentCart}
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    product.digit = false
  },
  ADD_SCANNER_PRODUCT: function (state, {selectedProduct, quantity}) {
    let product = state.products[selectedProduct.id] || { number: 0 }
    const sellerId = this.getters['session/getSellerId']
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    let currentCart = carts[state.currentCart]


    product.product_id = selectedProduct.id
    product.number+= quantity
    product.price_ttc = selectedProduct.price_ttc
    product.hasPromotion = selectedProduct.hasPromotion
    product.price_ttc_promo = selectedProduct.price_ttc_promo
    product.title = selectedProduct.title,
        product.remise = product.remise ? product.remise : 0
    product.price_offset = product.price_offset ? product.price_offset : 0
    product.declinaison = selectedProduct.declinaison
    product.currency_iso = selectedProduct.currency_iso
    product.currency = selectedProduct.currency
    state.currentProduct.product_id = selectedProduct.id

    state.products = {...state.products, ...{[selectedProduct.id]: product}}

    // stockage des produits dans le localStorage
    currentCart.products = state.products
    carts = {...carts, [state.currentCart]: currentCart}
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    product.digit = false
  },

  //supprimer un produit du panier
  DELETE_PRODUCT: function (state, deleteProduct) {
    deleteFormatProduct(state, deleteProduct)
    const sellerId = this.getters['session/getSellerId']
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    let currentCart = carts[state.currentCart]
    state.products = {...state.products}
    currentCart.products = state.products
    carts = {...carts, [state.currentCart]: currentCart}
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
  },

  //changer la quantité du produit avec le backspace
  QUANTITY_CHANGE_BY_BACKSPACE: function (state, productSelected) {
    let product = state.products[productSelected.product_id]

    if(product.digit){
      if (parseFloat(product.number) === 0){
        deleteFormatProduct(state, productSelected)
      } else {
        if (product.number.toString().length === 1){
          product.number = 1
        } else {
          product.number = product.number.toString().substring(0, product.number.toString().length - 1);
        }
      }
    }else{
      if (parseFloat(product.number) === 0){
        deleteFormatProduct(state, productSelected)
      }
      product.number = 0
    }




    const sellerId1 = this.getters['session/getSellerId']
    let carts1 = getCartsFromStorage(sellerId1, state.currentCart)
    let currentCart1 = carts1[state.currentCart]
    state.products = {...state.products}
    currentCart1.products = state.products
    carts1 = {...carts1, [state.currentCart]: currentCart1}
    localStorage.setItem('carts' + sellerId1, JSON.stringify(carts1))
  },

  //changer la remise du produit avec le backspace
  DISCOUNT_CHANGE_BY_BACKSPACE: function (state, productSelected) {
    let product = state.products[productSelected.product_id]

    if(parseFloat(product.remise) !== 0){
      if (product.remise.toString().length === 1){
        product.remise = 0
      } else {
        product.remise = product.remise.toString().substring(0, product.remise.toString().length - 1);
      }
    }else{
      product.remise = 0
    }

    const sellerIdD = this.getters['session/getSellerId']
    let cartsD = getCartsFromStorage(sellerIdD, state.currentCart)
    let currentCartD = cartsD[state.currentCart]
    state.products = {...state.products}
    currentCartD.products = state.products
    cartsD = {...cartsD, [state.currentCart]: currentCartD}
    localStorage.setItem('carts' + sellerIdD, JSON.stringify(cartsD))
  },
  //changer le prix du produit avec le backspace
  PRICE_OFFSET_CHANGE_BY_BACKSPACE: function (state, productSelected) {
    let product = state.products[productSelected.product_id]

    if(parseFloat(product.price_offset) !== 0){
      if (product.price_offset.toString().length === 1){
        product.price_offset = 0
      } else {
        product.price_offset = product.price_offset.toString().substring(0, product.price_offset.toString().length - 1);
      }
    }else{
      product.price_offset = 0
    }

    const sellerIdP = this.getters['session/getSellerId']
    let cartsP = getCartsFromStorage(sellerIdP, state.currentCart)
    let currentCartP = cartsP[state.currentCart]
    state.products = {...state.products}
    currentCartP.products = state.products
    cartsP = {...cartsP, [state.currentCart]: currentCartP}
    localStorage.setItem('carts' + sellerIdP, JSON.stringify(cartsP))
  },

  //changer le produit courant
  CHANGE_CURRENT_PRODUCT: function (state, product) {
    state.currentProduct.product_id = product.product_id
    const selectedProduct = state.products[product.product_id]
    if (selectedProduct) {
      selectedProduct.digit = false
    }
    state.products = {...state.products}
    const sellerIdC = this.getters['session/getSellerId']
    let cartsC = getCartsFromStorage(sellerIdC, state.currentCart)
    let currentCartC = cartsC[state.currentCart]
    currentCartC.currentProduct = state.currentProduct
    currentCartC.products = state.products
    cartsC = {...cartsC, [state.currentCart]: currentCartC}
    localStorage.setItem('carts' + sellerIdC, JSON.stringify(cartsC))
  },

  //réinitialiser la saisie de quantité du produit courant (ex: retour sur le bouton QTE)
  RESET_PRODUCT_DIGIT: function (state) {
    const product = state.products[state.currentProduct.product_id]
    if (product) {
      product.digit = false
    }
  },

  SET_PRODUCT_QUANTITY: function(state, { product, quantity, priceOverride }) {
    const sellerId = this.getters['session/getSellerId']
    const id = product.id ?? product.product_id
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    let currentCart = carts[state.currentCart]

    if (quantity <= 0) {
      const updated = { ...state.products }
      delete updated[id]
      state.products = updated
    } else {
      const existing = state.products[id] || {}
      state.products = {
        ...state.products,
        [id]: {
          ...existing,
          product_id: id,
          number: quantity,
          price_ttc: product.price_ttc,
          price_ttc_promo: product.price_ttc_promo,
          hasPromotion: product.hasPromotion,
          title: product.title,
          declinaison: product.declinaison,
          currency_iso: product.currency_iso,
          currency: product.currency,
          remise: existing.remise || 0,
          price_offset: priceOverride ?? existing.price_offset ?? 0,
        },
      }
    }

    currentCart.products = state.products
    carts = { ...carts, [state.currentCart]: currentCart }
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    state.totalAmount = computeCartTotal(state.products) + computeBundleCartTotal(state.bundles)
    state.currentProduct = state.products[id] || {}
  },

  // ajouter un pack au panier (ou incrémenter sa quantité)
  ADD_BUNDLE: function (state, selectedBundle) {
    const sellerId = this.getters['session/getSellerId']
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    let currentCart = carts[state.currentCart]

    const existing = state.bundles[selectedBundle.id] || { number: 0 }
    state.bundles = {
      ...state.bundles,
      [selectedBundle.id]: {
        bundle_id: selectedBundle.id,
        number: existing.number + 1,
        price_ttc: selectedBundle.price_ttc,
        title: selectedBundle.title,
        image: selectedBundle.image,
      },
    }

    currentCart.bundles = state.bundles
    carts = { ...carts, [state.currentCart]: currentCart }
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    state.totalAmount = computeCartTotal(state.products) + computeBundleCartTotal(state.bundles)
  },

  // retirer un pack du panier
  DELETE_BUNDLE: function (state, { bundle_id }) {
    const sellerId = this.getters['session/getSellerId']
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    let currentCart = carts[state.currentCart]

    const updated = { ...state.bundles }
    delete updated[bundle_id]
    state.bundles = updated

    currentCart.bundles = state.bundles
    carts = { ...carts, [state.currentCart]: currentCart }
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    state.totalAmount = computeCartTotal(state.products) + computeBundleCartTotal(state.bundles)
  },

  // fixer la quantité d'un pack (0 = suppression)
  SET_BUNDLE_QUANTITY: function (state, { bundle, quantity }) {
    const sellerId = this.getters['session/getSellerId']
    const id = bundle.id ?? bundle.bundle_id
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    let currentCart = carts[state.currentCart]

    if (quantity <= 0) {
      const updated = { ...state.bundles }
      delete updated[id]
      state.bundles = updated
    } else {
      const existing = state.bundles[id] || {}
      state.bundles = {
        ...state.bundles,
        [id]: {
          ...existing,
          bundle_id: id,
          number: quantity,
          price_ttc: bundle.price_ttc,
          title: bundle.title,
          image: bundle.image,
        },
      }
    }

    currentCart.bundles = state.bundles
    carts = { ...carts, [state.currentCart]: currentCart }
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    state.totalAmount = computeCartTotal(state.products) + computeBundleCartTotal(state.bundles)
  },

  // changer le panier courant
  CHANGE_CURRENT_CART: function(state, {cart, sellerId}){
    state.currentCart = parseInt(cart)
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    let currentCart = carts[state.currentCart]
    state.products = currentCart.products || {}
    state.bundles = currentCart.bundles || {}
    state.currentProduct = currentCart.currentProduct || {}
    state.checkoutMode = currentCart.checkoutMode || ''
    state.payments = currentCart.payments || []
    state.orderForm = currentCart.orderForm || null
    state.note = currentCart.note || ''
    state.discount = parseFloat(currentCart.discount) || 0
    state.amountDonated = { amount: 0, digit: false }
    state.totalAmount = computeCartTotal(state.products) + computeBundleCartTotal(state.bundles)
    let clienId = currentCart.clientId || null
    this.commit('posContact/SET_CLIENT_ID', {id: clienId, sellerId: sellerId, cart: state.currentCart})
  },

  // ADD_POMOTION_TO_PRODUCT: function(state, {selectedProduct, response}){
  //     let product = state.products[selectedProduct.product_id] || { number: 0 }
  //     product.id_promotion = response.id_promotion
  //     product.price_promotion = response.price_promotion
  //     product.title_promotion = response.title_promotion
  //     product.type_promotion = response.type_promotion
  //     state.products = {...state.products, ...{[selectedProduct.product_id]: product}}
  // },

  // SET_DONATED_AMOUNT_BY_FORM: function (state, amount) {
  //     state.amountDonated.amount = amount
  // },

  // INCREMENT_PRODUCT: function (state, product) {
  //     state.products[product.product_id].number++
  // },

  // DECREMENT_PRODUCT: function (state, product) {
  //     if (state.products[product.product_id].number > 1){
  //         state.products[product.product_id].number--
  //     }
  // },



  /*QUANTITY_CHANGE_BY_PAD: function (state, {digit, productSelected}) {
      let product = state.products[productSelected.product_id]
      if (product.extended) {
          let extendedProduct = product.products[productSelected.extended_id]
          if (!extendedProduct.digit){
              if (digit !== '.'){
                  extendedProduct.number = digit
              }else {
                  extendedProduct.number = extendedProduct.number + ''+ digit +''
              }
              extendedProduct.digit = true
          }else{
              extendedProduct.number = getNewQuantityValue(extendedProduct.number, digit)
          }
      }else {

          if (!product.digit){
              if (digit !== '.'){
                  product.number = digit
              } else {
                  product.number = product.number + ''+ digit +''
              }
              product.digit = true
          }else{
              product.number = getNewQuantityValue(product.number, digit)

          }
      }
  },*/


  SET_TOTAL_AMOUNT: function(state, amount){
    state.totalAmount = amount
    state.currency = this.getters['session/getCurrency'] ?? {iso: 'XOF', symbole: 'FCFA'}
  },

  SET_PAYMENTS_MODE: function(state, payments){
    state.payments = payments
    const sellerIdPm = this.getters['session/getSellerId']
    let cartsPm = getCartsFromStorage(sellerIdPm, state.currentCart)
    let currentCartPm = cartsPm[state.currentCart]
    currentCartPm.payments = payments
    cartsPm = {...cartsPm, [state.currentCart]: currentCartPm}
    localStorage.setItem('carts' + sellerIdPm, JSON.stringify(cartsPm))
  },

  SET_ORDER_FORM: function(state, form){
    state.orderForm = form ? {
      id: form.id,
      reference: form.reference,
      signature: orderFormSignature({ ...state, clientId: this.getters['posContact/getClientId'] }),
    } : null
    const sellerId = this.getters['session/getSellerId']
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    carts[state.currentCart].orderForm = state.orderForm
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
  },

  // Bon de commande rouvert : son contenu remplace celui du panier courant
  LOAD_ORDER_FORM: function(state, form){
    const keyed = (items, key) => Object.fromEntries((items || []).map(item => [item[key], { ...item, digit: false }]))
    state.products = keyed(form.products, 'product_id')
    // l'API renvoie '' en null (ConvertEmptyStringsToNull) : produit sans déclinaison → « null » affiché
    Object.values(state.products).forEach(product => { product.declinaison = product.declinaison || '' })
    state.bundles = keyed(form.bundles, 'bundle_id')
    state.currentProduct = {}
    state.payments = []
    state.checkoutMode = ''
    state.discount = parseFloat(form.discount) || 0
    state.note = form.note || ''
    state.orderForm = {
      id: form.id,
      reference: form.reference,
      signature: orderFormSignature({ ...state, clientId: form.customer ? form.customer.id : null }),
    }
    state.totalAmount = computeCartTotal(state.products) + computeBundleCartTotal(state.bundles)

    const sellerId = this.getters['session/getSellerId']
    let carts = getCartsFromStorage(sellerId, state.currentCart)
    carts[state.currentCart] = { ...carts[state.currentCart], products: state.products, bundles: state.bundles, currentProduct: {}, payments: [], checkoutMode: '', orderForm: state.orderForm, note: state.note, discount: state.discount }
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
  },

  SET_CREDIT: function(state, credit){
    state.credit = !!credit
  },

  SET_CREDIT_DUE_DATE: function(state, date){
    state.creditDueDate = date || ''
  },

  SET_CHECKOUT_MODE: function(state, mode){
    state.checkoutMode = mode
    const sellerIdCm = this.getters['session/getSellerId']
    let cartsCm = getCartsFromStorage(sellerIdCm, state.currentCart)
    let currentCartCm = cartsCm[state.currentCart]
    currentCartCm.checkoutMode = mode
    cartsCm = {...cartsCm, [state.currentCart]: currentCartCm}
    localStorage.setItem('carts' + sellerIdCm, JSON.stringify(cartsCm))
  },

  DONATE_AMOUNT_BY_PAD: function(state, digit){
    if (Object.values(state.products).length){
      if (digit === 'CLEAR'){
        state.amountDonated.amount = 0
        state.amountDonated.digit = true
      }else if(digit === 'BACKSPACE'){
        if (state.amountDonated.amount.toString().length === 1){
          state.amountDonated.amount = 0
        } else {
          state.amountDonated.amount = state.amountDonated.amount.substring(0, state.amountDonated.amount.length - 1);
        }
      } else {
        if (!state.amountDonated.digit){
          if (digit !== '.'){
            if (digit === '+10' || digit === '+20' || digit === '+50'){
              state.amountDonated.amount = state.amountDonated.amount + parseInt(digit.replace('+', ''))
            }else {
              state.amountDonated.amount = digit
            }
          }else {
            state.amountDonated.amount = state.amountDonated.amount + ''+ digit +''
          }
          state.amountDonated.digit = true
        }else{
          if (digit === '+10' || digit === '+20' || digit === '+50'){
            state.amountDonated.amount = parseFloat(state.amountDonated.amount) + parseInt(digit.replace('+', ''))
          }else {
            state.amountDonated.amount = getNewQuantityValue(state.amountDonated.amount, digit)
          }
        }
      }
    }
  },

  ADD_REDUCTIONS : function (state, reductions) {
    return state.reductions.data = reductions
  },

  SET_REM_ID: function (state, id) {
    let product = state.products[state.currentProduct.product_id]
    let rem = state.reductions.data.filter(reduction => reduction.id === id)
    if (rem[0]) {
      rem = rem[0]
      product.remId = rem.id
      product.remType = rem.type
      product.remAmount = rem.amount
    }
    state.products = {...state.products, ...{[state.currentProduct.product_id]: product}}
  },

  SET_NOTE: function (state, note) {
    state.note = note
    persistCartField(state, this.getters['session/getSellerId'], 'note', note || '')
  },

  DELETE_REM_ID: function (state) {
    let product = state.products[state.currentProduct.product_id]
    delete product.remId
    delete product.remType
    delete product.remAmount
    state.products = {...state.products, ...{[state.currentProduct.product_id]: product}}
  },

  SET_LOYALTY_REWARD: function (state, reward) {
    state.loyaltyRewardId = reward.id
    state.loyaltyRewardLabel = reward.label
    state.loyaltyRewardType = reward.reward_type
    state.loyaltyRewardValue = parseFloat(reward.reward_value) || 0
    state.loyaltyRewardProduct = reward.product || null
  },

  CLEAR_LOYALTY_REWARD: function (state) {
    state.loyaltyRewardId = null
    state.loyaltyRewardLabel = ''
    state.loyaltyRewardType = ''
    state.loyaltyRewardValue = 0
    state.loyaltyRewardProduct = null
  },

  SET_DISCOUNT: function (state, value) {
    const number = parseFloat(value)
    state.discount = Number.isNaN(number) ? 0 : Math.min(100, Math.max(0, number))
    persistCartField(state, this.getters['session/getSellerId'], 'discount', state.discount)
  },

  CLEAR_DISCOUNT: function (state) {
    state.discount = 0
    persistCartField(state, this.getters['session/getSellerId'], 'discount', 0)
  },

  RESET_CART: function (state) {
    state.orderForm = null
    state.note = ''
    state.credit = false
    state.creditDueDate = ''
    state.products = {}
    state.bundles = {}
    state.amountDonated = { amount: 0, digit: false }
    state.checkoutMode = ''
    state.payments = []
    state.loyaltyRewardId = null
    state.loyaltyRewardLabel = ''
    state.loyaltyRewardType = ''
    state.loyaltyRewardValue = 0
    state.loyaltyRewardProduct = null
    state.discount = 0

    const sellerIdR = this.getters['session/getSellerId']
    let cartsR = getCartsFromStorage(sellerIdR, state.currentCart)
    let currentCartR = cartsR[state.currentCart]
    currentCartR.products = {}
    currentCartR.bundles = {}
    currentCartR.currentProduct = {}
    currentCartR.checkoutMode = ''
    currentCartR.payments = []
    currentCartR.clientId = null
    currentCartR.orderForm = null
    currentCartR.note = ''
    currentCartR.discount = 0
    cartsR = {...cartsR, [state.currentCart]: currentCartR}
    localStorage.setItem('carts' + sellerIdR, JSON.stringify(cartsR))
  },

  SET_PRODUCT : function (state, products) {
    state.products = {...products}
    state.totalAmount = computeCartTotal(state.products) + computeBundleCartTotal(state.bundles)
  },

  CLEAR_ALL_CARTS: function (state) {
    const keysToRemove = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith('carts')) keysToRemove.push(key)
    }
    keysToRemove.forEach(key => localStorage.removeItem(key))
    state.products = {}
    state.bundles = {}
    state.currentProduct = {}
    state.checkoutMode = ''
    state.payments = []
    state.currentCart = 0
    state.cartIndices = [0]
    state.note = ''
    state.discount = 0
    state.amountDonated = { amount: 0, digit: false }
  },

  INIT_CARTS: function (state) {
    const sellerId = this.getters['session/getSellerId']
    if (!sellerId) return
    let carts = JSON.parse(localStorage.getItem('carts' + sellerId)) || {}
    if (!Object.keys(carts).length) {
      carts[0] = emptyCart()
      localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    }
    const indices = Object.keys(carts).map(Number).sort((a, b) => a - b)
    state.cartIndices = indices
    const first = indices[0]
    state.currentCart = first
    const cart = carts[first]
    state.products = cart.products || {}
    state.bundles = cart.bundles || {}
    state.currentProduct = cart.currentProduct || {}
    state.checkoutMode = cart.checkoutMode || ''
    state.payments = cart.payments || []
    state.orderForm = cart.orderForm || null
    state.note = cart.note || ''
    state.discount = parseFloat(cart.discount) || 0
    state.totalAmount = computeCartTotal(state.products) + computeBundleCartTotal(state.bundles)

    if (cart.clientId) {
      this.commit('posContact/SET_CLIENT_ID', { id: cart.clientId, sellerId, cart: first })
    }
  },

  ADD_CART: function (state) {
    const sellerId = this.getters['session/getSellerId']
    let carts = JSON.parse(localStorage.getItem('carts' + sellerId)) || {}
    const indices = Object.keys(carts).map(Number)
    const newIndex = indices.length ? Math.max(...indices) + 1 : 1
    carts[newIndex] = emptyCart()
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    state.cartIndices = Object.keys(carts).map(Number).sort((a, b) => a - b)
    state.currentCart = newIndex
    state.products = {}
    state.bundles = {}
    state.currentProduct = {}
    state.checkoutMode = ''
    state.payments = []
    state.orderForm = null
    state.note = ''
    state.discount = 0
    state.amountDonated = { amount: 0, digit: false }
    state.totalAmount = 0
  },

  DELETE_CART: function (state, cartIndex) {
    const sellerId = this.getters['session/getSellerId']
    let carts = JSON.parse(localStorage.getItem('carts' + sellerId)) || {}
    delete carts[cartIndex]
    if (!Object.keys(carts).length) {
      carts[0] = emptyCart()
    }
    localStorage.setItem('carts' + sellerId, JSON.stringify(carts))
    const remaining = Object.keys(carts).map(Number).sort((a, b) => a - b)
    state.cartIndices = remaining
    const next = remaining[0]
    state.currentCart = next
    const currentCart = carts[next]
    state.products = currentCart.products || {}
    state.bundles = currentCart.bundles || {}
    state.currentProduct = currentCart.currentProduct || {}
    state.checkoutMode = currentCart.checkoutMode || ''
    state.payments = currentCart.payments || []
    state.orderForm = currentCart.orderForm || null
    state.note = currentCart.note || ''
    state.discount = parseFloat(currentCart.discount) || 0
    state.totalAmount = computeCartTotal(state.products) + computeBundleCartTotal(state.bundles)
  },


  [LOAD_PAYMENT_METHOD](state, data) {
    state.paymentMethods = data
  },
}
